module.exports = __webpack_public_path__ + "img/working-hours.f388bf0e.png";